<template>
    <div class="lnk-form-card">
		<div :class="{'lnk-form-card__header':true,'no-buttons':!$slots['header-button']}" v-if="title || $slots.header">
			<slot name="header">{{title}}</slot>
			<div class="header-right" v-if="$slots['header-button']">
				<slot name="header-button"></slot>
			</div>
		</div>
		<div class="lnk-form-card__content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
    export default {
        name: "lnk-form-card",
		props:{
        	/*标题*/
        	title:String
		}
    }
</script>

<style lang="scss">
	.lnk-form-card{
		.lnk-form-card__header{
			font-size:14px;
			font-weight: 500;
			color: rgba(0,0,0,0.85);
			letter-spacing: 1px;
			padding: 8px 16px;
			line-height: 28px;
			border-bottom: 1px solid #F0F2F7;
			&.no-buttons{
				padding: 12px 16px;
				line-height: 1;
			}
			.link-button+.link-button{
				margin-left: 8px;
			}
		}
		.header-right{
			float: right;
			display: inline-flex;
		}
		.el-tabs__nav.is-top{
			margin-left: 16px;
		}
	}
	@include themeify{
		.lnk-form-card+.lnk-form-card,
		.lnk-form-panel+.lnk-form-card{
			border-top: 16px solid $background;
		}
		.lnk-form-card{
			.el-tabs__active-bar{
				background-color: pl-var(color-primary);
			}
			.el-tabs__item.is-active{
				color: pl-var(color-primary);
			}
		}
	}

</style>
